import { IconButton, IconButtonProps } from '@mui/material';
import { IconPlayerPause } from '@tabler/icons-react';
import { DS } from './ds';

interface DeactivateButtonProps extends Omit<IconButtonProps, 'children'> {
  iconSize?: number;
}

const DeactivateButton = ({ iconSize = 18, sx, ...rest }: DeactivateButtonProps) => (
  <IconButton
    size="small"
    title="Desactivar"
    sx={{ color: DS.warning, '&:hover': { bgcolor: '#fef3c7' }, ...sx }}
    {...rest}
  >
    <IconPlayerPause size={iconSize} />
  </IconButton>
);

export default DeactivateButton;
